export default __webpack_public_path__ + "static/dashboard-dd525c696fb8181b6e1bcdb884cfa3a5.svg";